import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { IngestionCreateForm } from "./components/IngestionCreateForm";

export function NewIngestionPage() {
  return (
    <Page title="New Ingestion">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <IngestionCreateForm />
      </Container>
    </Page>
  );
}
